import { RodtepStatus } from "@gtpl/shared-models/common-models"

export class RodteStatusReq {
    soId:number
    status:RodtepStatus
    constructor(
        soId:number,
    status:RodtepStatus
    ){
        this.soId = soId
        this.status = status
    }
}